import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-alert-calendar-open',
  templateUrl: './alert-calendar-open.component.html',
  styleUrls: ['./alert-calendar-open.component.scss']
})
export class AlertCalendarOpenComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
